import { cookies } from 'next/headers'
import xss from 'xss'
type NextCookies = ReturnType<typeof cookies>

// https://giphy.com/search/%08%3E%3Cscript%3Ealert%28origin%29%3C%2Fscript
export const safeDecodeURIComponent = (str: string = '') => {
    try {
        const decoded = decodeURIComponent(str)
        return xss(decoded)
    } catch (e) {
        console.error(`error decoding ${str}`, e)
    }
    return str
}

export const getCookieString = (cookies: NextCookies) => {
    return cookies
        .getAll()
        .map(({ name, value }) => `${name}=${value}`)
        .join('; ')
}

export type Cookies = string | NextCookies

/**
 * Ensures a URL has a protocol (http or https).
 *
 * Leaves protocol-relative URLs (e.g. `//example.com`) unchanged so they
 * keep inheriting the current page’s protocol.
 */
export const addProtocol = (
  url: string,
  type: 'http' | 'https' = 'https'
): string => {
  // Already has a protocol (`http://`, `https://`) or is protocol-relative (`//`)
  if (/^(https?:)?\/\//i.test(url)) {
    return url
  }

  return `${type}://${url}`
}
/**
 * util mostly just to set cookies correctly on client and server
 */
export const GET = (cookie: Cookies = ''): RequestInit => {
    if (typeof cookie === 'object') {
        cookie = getCookieString(cookie as NextCookies)
    }
    return {
        method: 'get',
        headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            cookie: cookie || (typeof document === 'undefined' ? '' : document?.cookie),
        },
    }
}
